import Vue from 'vue'
import router from './router'
import store from './store/index'

// buefy
import Buefy from 'buefy'
import '@/assets/stylesheets/buefy.scss'
Vue.use(Buefy, {
  defaultIconPack: 'fas'
})

import 'lodash'
Vue.use(require('vue-moment'))

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faHome, faUser)
Vue.component('fa', FontAwesomeIcon)

// webtk
import './api'

// webtk components ??
// import MfwebtkVue from 'mfwebtk-vue'
// Vue.use(MfwebtkVue)

import '@/assets/stylesheets/app.scss'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h('router-view')
}).$mount('#app')
